import { getHeaders } from "../request-headers.ts";
import type { ApexStyleAnalysisRequest, GetPlayerStatisticsParams } from "../../model";

import { cnapexApiFetch } from "../../../fetcher.ts";

export const getGetMapRotationUrl = () => {
  return `/api/apex/map-rotation`;
};

export const getMapRotation = async (
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<unknown> => {
  return cnapexApiFetch<unknown>(getGetMapRotationUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPlayerStatisticsUrl = (params: GetPlayerStatisticsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/apex/player-statistics?${stringifiedParams}`
    : `/api/apex/player-statistics`;
};

export const getPlayerStatistics = async (
  params: GetPlayerStatisticsParams,
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<unknown> => {
  return cnapexApiFetch<unknown>(getGetPlayerStatisticsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPredatorThresholdUrl = () => {
  return `/api/apex/predator-threshold`;
};

export const getPredatorThreshold = async (
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<unknown> => {
  return cnapexApiFetch<unknown>(getGetPredatorThresholdUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetServerStatusUrl = () => {
  return `/api/apex/server-status`;
};

export const getServerStatus = async (
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<unknown> => {
  return cnapexApiFetch<unknown>(getGetServerStatusUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAnalyzeApexStyleUrl = () => {
  return `/api/apex/style-analysis`;
};

export const analyzeApexStyle = async (
  apexStyleAnalysisRequest: ApexStyleAnalysisRequest,
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<string> => {
  return cnapexApiFetch<string>(getAnalyzeApexStyleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...getHeaders(options?.headers) },
    body: JSON.stringify(apexStyleAnalysisRequest),
  });
};

export const getGetUpLiveStatusUrl = () => {
  return `/api/apex/up-live-status`;
};

export const getUpLiveStatus = async (
  options?: Parameters<typeof cnapexApiFetch>[1],
): Promise<unknown> => {
  return cnapexApiFetch<unknown>(getGetUpLiveStatusUrl(), {
    ...options,
    method: "GET",
  });
};
